import React from 'react'
import './SapCalendar.css'
import {Image, Container} from 'react-bootstrap';
import NavTabs from '../sap-components/sap-calendar/NavTabs';
import NavTabsNew from '../sap-components/sap-calendar/NavTabsNew';
import { useMsal } from "@azure/msal-react";

function SapCalendar() {
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
      
    let ipsLoggedInEnterpriseId = '';  
    if(activeAccount) {
      ipsLoggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;     
    }

    const allowedUsersForSAPCalendar = [ 
      'h.srinivasan',         
      'jeevadharani.ramanan',
      'ankur.e.mishra',
      's.rao.masipeddi',  
      'arpita.m.singh',
      'aayushi.bharti',
      'aluru.akash',       
      'uma.rani.battu',
      'reshmi.haridas.m',        
      'rajath.mb',                                
      'j.b.bhardwaj',
      'shramika.s.ambolkar'
    ];
    return (
      <>
        {/* Banner Image */}
        <div>
          <Image className="banner__image" src={process.env.PUBLIC_URL + "/images/SAP/sap_calendar/banner.jpg"}></Image>
        </div>

        {/* Heading */}
        <Container fluid>
          <div className="first-head container__fluid">
            {/* <p className="level1-heading">About SAP</p>
            <p className="first-head">
              {" "}
              In today’s fast driven technology ecosystem, SAP is the market
              leader in providing ERP (Enterprise Resource Planning) solutions
              and services. SAP acts as an enterprise wide information system
              designed to support and integrate almost all the functional areas
              of business processes such as Human Resources, Sales and
              Distribution, Finance, Logistics, Production Planning,
              Manufacturing, etc. SAP has evolved to what it is today; providing
              solutions on the latest technical advancements like Cloud, Big
              data, IoT, Artificial Intelligence, Machine Learning, Analytics
              and so on.
            </p> */}
          </div>
        </Container>
        {allowedUsersForSAPCalendar.includes(ipsLoggedInEnterpriseId) ?
        <NavTabsNew />
        : <NavTabs /> }                                            
      </>
    );
}

export default SapCalendar
